/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateNoPreviousPurchaseType = exports.TaxTypeConfigurationTaxType = exports.TaxSettingsTaxType = exports.SubscriptionUpgradeType = exports.ServiceStatus = exports.ServiceRecurringType = exports.PurchaseScenario = exports.PaymentType = exports.PaymentCycle = exports.MailboxSaleType = exports.MailboxOldSaleType = exports.IntervalUnit = exports.FreeTrialIneligibilityReasonEnum = exports.FeaturePeriod = exports.DurationUnit = exports.CycleUnitType = exports.CycleType = exports.CurrencyCode = exports.ContractSwitchType = exports.BillingCycle = void 0;
var BillingCycle;
(function (BillingCycle) {
    BillingCycle["ONE_TIME"] = "ONE_TIME";
    BillingCycle["DAILY"] = "DAILY";
    BillingCycle["WEEKLY"] = "WEEKLY";
    BillingCycle["MONTHLY"] = "MONTHLY";
    BillingCycle["QUARTERLY"] = "QUARTERLY";
    BillingCycle["SEMI_ANNUALLY"] = "SEMI_ANNUALLY";
    BillingCycle["YEARLY"] = "YEARLY";
    BillingCycle["TWO_YEARS"] = "TWO_YEARS";
    BillingCycle["THREE_YEARS"] = "THREE_YEARS";
    BillingCycle["FOUR_YEARS"] = "FOUR_YEARS";
    BillingCycle["FIVE_YEARS"] = "FIVE_YEARS";
    BillingCycle["SIX_YEARS"] = "SIX_YEARS";
    BillingCycle["SEVEN_YEARS"] = "SEVEN_YEARS";
    BillingCycle["EIGHT_YEARS"] = "EIGHT_YEARS";
    BillingCycle["NINE_YEARS"] = "NINE_YEARS";
    BillingCycle["TEN_YEARS"] = "TEN_YEARS";
})(BillingCycle = exports.BillingCycle || (exports.BillingCycle = {}));
var ContractSwitchType;
(function (ContractSwitchType) {
    ContractSwitchType["UNKNOWN"] = "UNKNOWN";
    ContractSwitchType["CREDIT_UNUSED_PERIOD"] = "CREDIT_UNUSED_PERIOD";
    ContractSwitchType["EXTEND"] = "EXTEND";
    ContractSwitchType["FULL_AMOUNT_PERIOD"] = "FULL_AMOUNT_PERIOD";
    ContractSwitchType["DOWNGRADE_RENEWAL"] = "DOWNGRADE_RENEWAL";
})(ContractSwitchType = exports.ContractSwitchType || (exports.ContractSwitchType = {}));
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["AED"] = "AED";
    CurrencyCode["AFN"] = "AFN";
    CurrencyCode["ALL"] = "ALL";
    CurrencyCode["AMD"] = "AMD";
    CurrencyCode["ANG"] = "ANG";
    CurrencyCode["ARS"] = "ARS";
    CurrencyCode["AUD"] = "AUD";
    CurrencyCode["AWG"] = "AWG";
    CurrencyCode["AZN"] = "AZN";
    CurrencyCode["BAM"] = "BAM";
    CurrencyCode["BBD"] = "BBD";
    CurrencyCode["BDT"] = "BDT";
    CurrencyCode["BEF"] = "BEF";
    CurrencyCode["BGL"] = "BGL";
    CurrencyCode["BGN"] = "BGN";
    CurrencyCode["BHD"] = "BHD";
    CurrencyCode["BIF"] = "BIF";
    CurrencyCode["BMD"] = "BMD";
    CurrencyCode["BND"] = "BND";
    CurrencyCode["BOB"] = "BOB";
    CurrencyCode["BRL"] = "BRL";
    CurrencyCode["BSD"] = "BSD";
    CurrencyCode["BWP"] = "BWP";
    CurrencyCode["BYR"] = "BYR";
    CurrencyCode["BZD"] = "BZD";
    CurrencyCode["CAD"] = "CAD";
    CurrencyCode["CDF"] = "CDF";
    CurrencyCode["CHF"] = "CHF";
    CurrencyCode["CLP"] = "CLP";
    CurrencyCode["CNY"] = "CNY";
    CurrencyCode["COP"] = "COP";
    CurrencyCode["CRC"] = "CRC";
    CurrencyCode["CUP"] = "CUP";
    CurrencyCode["CVE"] = "CVE";
    CurrencyCode["CYP"] = "CYP";
    CurrencyCode["CZK"] = "CZK";
    CurrencyCode["DJF"] = "DJF";
    CurrencyCode["DKK"] = "DKK";
    CurrencyCode["DOP"] = "DOP";
    CurrencyCode["DZD"] = "DZD";
    CurrencyCode["EEK"] = "EEK";
    CurrencyCode["EGP"] = "EGP";
    CurrencyCode["ERN"] = "ERN";
    CurrencyCode["ESP"] = "ESP";
    CurrencyCode["ETB"] = "ETB";
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["FJD"] = "FJD";
    CurrencyCode["FKP"] = "FKP";
    CurrencyCode["FRF"] = "FRF";
    CurrencyCode["GBP"] = "GBP";
    CurrencyCode["GEL"] = "GEL";
    CurrencyCode["GHC"] = "GHC";
    CurrencyCode["GHS"] = "GHS";
    CurrencyCode["GIP"] = "GIP";
    CurrencyCode["GMD"] = "GMD";
    CurrencyCode["GNF"] = "GNF";
    CurrencyCode["GRD"] = "GRD";
    CurrencyCode["GTQ"] = "GTQ";
    CurrencyCode["GYD"] = "GYD";
    CurrencyCode["HKD"] = "HKD";
    CurrencyCode["HNL"] = "HNL";
    CurrencyCode["HRK"] = "HRK";
    CurrencyCode["HTG"] = "HTG";
    CurrencyCode["HUF"] = "HUF";
    CurrencyCode["IDR"] = "IDR";
    CurrencyCode["IEP"] = "IEP";
    CurrencyCode["ILS"] = "ILS";
    CurrencyCode["INR"] = "INR";
    CurrencyCode["IQD"] = "IQD";
    CurrencyCode["IRR"] = "IRR";
    CurrencyCode["ISK"] = "ISK";
    CurrencyCode["ITL"] = "ITL";
    CurrencyCode["JMD"] = "JMD";
    CurrencyCode["JOD"] = "JOD";
    CurrencyCode["JPY"] = "JPY";
    CurrencyCode["KES"] = "KES";
    CurrencyCode["KGS"] = "KGS";
    CurrencyCode["KHR"] = "KHR";
    CurrencyCode["KMF"] = "KMF";
    CurrencyCode["KPW"] = "KPW";
    CurrencyCode["KRW"] = "KRW";
    CurrencyCode["KWD"] = "KWD";
    CurrencyCode["KYD"] = "KYD";
    CurrencyCode["KZT"] = "KZT";
    CurrencyCode["LAK"] = "LAK";
    CurrencyCode["LBP"] = "LBP";
    CurrencyCode["LKR"] = "LKR";
    CurrencyCode["LRD"] = "LRD";
    CurrencyCode["LSL"] = "LSL";
    CurrencyCode["LTL"] = "LTL";
    CurrencyCode["LUF"] = "LUF";
    CurrencyCode["LVL"] = "LVL";
    CurrencyCode["LYD"] = "LYD";
    CurrencyCode["MAD"] = "MAD";
    CurrencyCode["MDL"] = "MDL";
    CurrencyCode["MGA"] = "MGA";
    CurrencyCode["MKD"] = "MKD";
    CurrencyCode["MMK"] = "MMK";
    CurrencyCode["MNT"] = "MNT";
    CurrencyCode["MOP"] = "MOP";
    CurrencyCode["MRO"] = "MRO";
    CurrencyCode["MTL"] = "MTL";
    CurrencyCode["MUR"] = "MUR";
    CurrencyCode["MVR"] = "MVR";
    CurrencyCode["MWK"] = "MWK";
    CurrencyCode["MXN"] = "MXN";
    CurrencyCode["MYR"] = "MYR";
    CurrencyCode["MZN"] = "MZN";
    CurrencyCode["NAD"] = "NAD";
    CurrencyCode["NGN"] = "NGN";
    CurrencyCode["NIO"] = "NIO";
    CurrencyCode["NLG"] = "NLG";
    CurrencyCode["NOK"] = "NOK";
    CurrencyCode["NPR"] = "NPR";
    CurrencyCode["NZD"] = "NZD";
    CurrencyCode["OMR"] = "OMR";
    CurrencyCode["PAB"] = "PAB";
    CurrencyCode["PEN"] = "PEN";
    CurrencyCode["PGK"] = "PGK";
    CurrencyCode["PHP"] = "PHP";
    CurrencyCode["PKR"] = "PKR";
    CurrencyCode["PLN"] = "PLN";
    CurrencyCode["PYG"] = "PYG";
    CurrencyCode["QAR"] = "QAR";
    CurrencyCode["RON"] = "RON";
    CurrencyCode["RSD"] = "RSD";
    CurrencyCode["RUB"] = "RUB";
    CurrencyCode["RWF"] = "RWF";
    CurrencyCode["SAR"] = "SAR";
    CurrencyCode["SBD"] = "SBD";
    CurrencyCode["SCR"] = "SCR";
    CurrencyCode["SDG"] = "SDG";
    CurrencyCode["SEK"] = "SEK";
    CurrencyCode["SGD"] = "SGD";
    CurrencyCode["SHP"] = "SHP";
    CurrencyCode["SKK"] = "SKK";
    CurrencyCode["SLL"] = "SLL";
    CurrencyCode["SOS"] = "SOS";
    CurrencyCode["SRD"] = "SRD";
    CurrencyCode["STD"] = "STD";
    CurrencyCode["SVC"] = "SVC";
    CurrencyCode["SYP"] = "SYP";
    CurrencyCode["SZL"] = "SZL";
    CurrencyCode["THB"] = "THB";
    CurrencyCode["TJS"] = "TJS";
    CurrencyCode["TMT"] = "TMT";
    CurrencyCode["TND"] = "TND";
    CurrencyCode["TOP"] = "TOP";
    CurrencyCode["TRL"] = "TRL";
    CurrencyCode["TRY"] = "TRY";
    CurrencyCode["TTD"] = "TTD";
    CurrencyCode["TWD"] = "TWD";
    CurrencyCode["TZS"] = "TZS";
    CurrencyCode["UAH"] = "UAH";
    CurrencyCode["UGX"] = "UGX";
    CurrencyCode["USD"] = "USD";
    CurrencyCode["UYU"] = "UYU";
    CurrencyCode["UZS"] = "UZS";
    CurrencyCode["VEB"] = "VEB";
    CurrencyCode["VEF"] = "VEF";
    CurrencyCode["VND"] = "VND";
    CurrencyCode["VUV"] = "VUV";
    CurrencyCode["WST"] = "WST";
    CurrencyCode["XAF"] = "XAF";
    CurrencyCode["XAG"] = "XAG";
    CurrencyCode["XAU"] = "XAU";
    CurrencyCode["XCD"] = "XCD";
    CurrencyCode["XEU"] = "XEU";
    CurrencyCode["XOF"] = "XOF";
    CurrencyCode["XPD"] = "XPD";
    CurrencyCode["XPF"] = "XPF";
    CurrencyCode["XPT"] = "XPT";
    CurrencyCode["YER"] = "YER";
    CurrencyCode["ZAR"] = "ZAR";
    CurrencyCode["ZMK"] = "ZMK";
    CurrencyCode["ZMW"] = "ZMW";
    CurrencyCode["ZWD"] = "ZWD";
    CurrencyCode["ZWL"] = "ZWL";
    CurrencyCode["BYN"] = "BYN";
    CurrencyCode["AOA"] = "AOA";
    CurrencyCode["MZM"] = "MZM";
    CurrencyCode["TMM"] = "TMM";
    CurrencyCode["ROL"] = "ROL";
    CurrencyCode["BTN"] = "BTN";
    CurrencyCode["MRU"] = "MRU";
    CurrencyCode["VES"] = "VES";
    CurrencyCode["STN"] = "STN";
    CurrencyCode["RUR"] = "RUR";
})(CurrencyCode = exports.CurrencyCode || (exports.CurrencyCode = {}));
var CycleType;
(function (CycleType) {
    CycleType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    CycleType["ONE_TIME"] = "ONE_TIME";
    CycleType["RECURRING"] = "RECURRING";
})(CycleType = exports.CycleType || (exports.CycleType = {}));
var CycleUnitType;
(function (CycleUnitType) {
    CycleUnitType["ONE_TIME"] = "ONE_TIME";
    CycleUnitType["DAILY"] = "DAILY";
    CycleUnitType["WEEKLY"] = "WEEKLY";
    CycleUnitType["MONTHLY"] = "MONTHLY";
    CycleUnitType["QUARTERLY"] = "QUARTERLY";
    CycleUnitType["SEMI_ANNUALLY"] = "SEMI_ANNUALLY";
    CycleUnitType["YEARLY"] = "YEARLY";
    CycleUnitType["TWO_YEARS"] = "TWO_YEARS";
    CycleUnitType["THREE_YEARS"] = "THREE_YEARS";
    CycleUnitType["FOUR_YEARS"] = "FOUR_YEARS";
    CycleUnitType["FIVE_YEARS"] = "FIVE_YEARS";
    CycleUnitType["SIX_YEARS"] = "SIX_YEARS";
    CycleUnitType["SEVEN_YEARS"] = "SEVEN_YEARS";
    CycleUnitType["EIGHT_YEARS"] = "EIGHT_YEARS";
    CycleUnitType["NINE_YEARS"] = "NINE_YEARS";
    CycleUnitType["TEN_YEARS"] = "TEN_YEARS";
})(CycleUnitType = exports.CycleUnitType || (exports.CycleUnitType = {}));
var DurationUnit;
(function (DurationUnit) {
    DurationUnit["UNKNOWN_UNIT"] = "UNKNOWN_UNIT";
    DurationUnit["DAY"] = "DAY";
    DurationUnit["WEEK"] = "WEEK";
    DurationUnit["MONTH"] = "MONTH";
    DurationUnit["YEAR"] = "YEAR";
})(DurationUnit = exports.DurationUnit || (exports.DurationUnit = {}));
var FeaturePeriod;
(function (FeaturePeriod) {
    FeaturePeriod["NO_PERIOD"] = "NO_PERIOD";
    FeaturePeriod["MILLISECOND"] = "MILLISECOND";
    FeaturePeriod["SECOND"] = "SECOND";
    FeaturePeriod["MINUTE"] = "MINUTE";
    FeaturePeriod["HOUR"] = "HOUR";
    FeaturePeriod["DAY"] = "DAY";
    FeaturePeriod["WEEK"] = "WEEK";
    FeaturePeriod["MONTH"] = "MONTH";
    FeaturePeriod["YEAR"] = "YEAR";
})(FeaturePeriod = exports.FeaturePeriod || (exports.FeaturePeriod = {}));
var FreeTrialIneligibilityReasonEnum;
(function (FreeTrialIneligibilityReasonEnum) {
    FreeTrialIneligibilityReasonEnum["UNKNOWN"] = "UNKNOWN";
    FreeTrialIneligibilityReasonEnum["ACCOUNT_NOT_ELIGIBLE"] = "ACCOUNT_NOT_ELIGIBLE";
    FreeTrialIneligibilityReasonEnum["NOT_INITIAL_PURCHASE"] = "NOT_INITIAL_PURCHASE";
    FreeTrialIneligibilityReasonEnum["NO_FREE_TRIAL_PRODUCT"] = "NO_FREE_TRIAL_PRODUCT";
})(FreeTrialIneligibilityReasonEnum = exports.FreeTrialIneligibilityReasonEnum || (exports.FreeTrialIneligibilityReasonEnum = {}));
var IntervalUnit;
(function (IntervalUnit) {
    IntervalUnit["UNKNOWN"] = "UNKNOWN";
    IntervalUnit["DAY"] = "DAY";
    IntervalUnit["WEEK"] = "WEEK";
    IntervalUnit["MONTH"] = "MONTH";
    IntervalUnit["YEAR"] = "YEAR";
})(IntervalUnit = exports.IntervalUnit || (exports.IntervalUnit = {}));
var MailboxOldSaleType;
(function (MailboxOldSaleType) {
    MailboxOldSaleType["NO_SALE"] = "NO_SALE";
    MailboxOldSaleType["SEASONAL_SALE"] = "SEASONAL_SALE";
    MailboxOldSaleType["PERSONAL_SALE"] = "PERSONAL_SALE";
})(MailboxOldSaleType = exports.MailboxOldSaleType || (exports.MailboxOldSaleType = {}));
var MailboxSaleType;
(function (MailboxSaleType) {
    MailboxSaleType["UNKNOWN_SALE_TYPE"] = "UNKNOWN_SALE_TYPE";
    MailboxSaleType["NO_SALE"] = "NO_SALE";
    MailboxSaleType["SEASONAL_SALE"] = "SEASONAL_SALE";
    MailboxSaleType["PERSONAL_SALE"] = "PERSONAL_SALE";
    MailboxSaleType["MIGRATION"] = "MIGRATION";
})(MailboxSaleType = exports.MailboxSaleType || (exports.MailboxSaleType = {}));
var PaymentCycle;
(function (PaymentCycle) {
    PaymentCycle["DAILY"] = "DAILY";
    PaymentCycle["WEEKLY"] = "WEEKLY";
    PaymentCycle["MONTHLY"] = "MONTHLY";
    PaymentCycle["QUARTERLY"] = "QUARTERLY";
    PaymentCycle["SEMIANNUALLY"] = "SEMIANNUALLY";
    PaymentCycle["YEARLY"] = "YEARLY";
    PaymentCycle["YEAR2"] = "YEAR2";
    PaymentCycle["YEAR3"] = "YEAR3";
    PaymentCycle["YEAR4"] = "YEAR4";
    PaymentCycle["YEAR5"] = "YEAR5";
    PaymentCycle["YEAR10"] = "YEAR10";
    PaymentCycle["ONE_TIME"] = "ONE_TIME";
})(PaymentCycle = exports.PaymentCycle || (exports.PaymentCycle = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["UNKNOWN"] = "UNKNOWN";
    PaymentType["RECURRING"] = "RECURRING";
    PaymentType["REAL_TIME"] = "REAL_TIME";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var PurchaseScenario;
(function (PurchaseScenario) {
    PurchaseScenario["UNAUTHORIZED"] = "UNAUTHORIZED";
    PurchaseScenario["ACCOUNT_LEVEL"] = "ACCOUNT_LEVEL";
    PurchaseScenario["PURCHASE"] = "PURCHASE";
    PurchaseScenario["VIEW"] = "VIEW";
    PurchaseScenario["EMPTY_OFFERING"] = "EMPTY_OFFERING";
    PurchaseScenario["ANONYMOUS"] = "ANONYMOUS";
})(PurchaseScenario = exports.PurchaseScenario || (exports.PurchaseScenario = {}));
var ServiceRecurringType;
(function (ServiceRecurringType) {
    ServiceRecurringType["AUTO"] = "AUTO";
    ServiceRecurringType["OFF"] = "OFF";
    ServiceRecurringType["MANUAL"] = "MANUAL";
})(ServiceRecurringType = exports.ServiceRecurringType || (exports.ServiceRecurringType = {}));
var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus["ACTIVE"] = "ACTIVE";
    ServiceStatus["PENDING"] = "PENDING";
    ServiceStatus["CANCELED"] = "CANCELED";
    ServiceStatus["FRAUDULENT"] = "FRAUDULENT";
    ServiceStatus["COLLECTIONS"] = "COLLECTIONS";
    ServiceStatus["WORK_IN_PROGRESS"] = "WORK_IN_PROGRESS";
    ServiceStatus["SUSPENDED"] = "SUSPENDED";
    ServiceStatus["FAILED"] = "FAILED";
    ServiceStatus["PENDING_RENEWAL"] = "PENDING_RENEWAL";
    ServiceStatus["EXPIRED"] = "EXPIRED";
    ServiceStatus["STOPPED"] = "STOPPED";
    ServiceStatus["STARTED"] = "STARTED";
    ServiceStatus["SUBMITTED"] = "SUBMITTED";
    ServiceStatus["COMPLETED"] = "COMPLETED";
    ServiceStatus["TRANSFERRED"] = "TRANSFERRED";
    ServiceStatus["DRAFT"] = "DRAFT";
})(ServiceStatus = exports.ServiceStatus || (exports.ServiceStatus = {}));
var SubscriptionUpgradeType;
(function (SubscriptionUpgradeType) {
    SubscriptionUpgradeType["UNKNOWN"] = "UNKNOWN";
    SubscriptionUpgradeType["CREDIT_UNUSED_PERIOD"] = "CREDIT_UNUSED_PERIOD";
    SubscriptionUpgradeType["EXTEND"] = "EXTEND";
})(SubscriptionUpgradeType = exports.SubscriptionUpgradeType || (exports.SubscriptionUpgradeType = {}));
var TaxSettingsTaxType;
(function (TaxSettingsTaxType) {
    TaxSettingsTaxType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TaxSettingsTaxType["VAT"] = "VAT";
    TaxSettingsTaxType["GST"] = "GST";
})(TaxSettingsTaxType = exports.TaxSettingsTaxType || (exports.TaxSettingsTaxType = {}));
var TaxTypeConfigurationTaxType;
(function (TaxTypeConfigurationTaxType) {
    TaxTypeConfigurationTaxType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TaxTypeConfigurationTaxType["REGULAR"] = "REGULAR";
    TaxTypeConfigurationTaxType["EU_VAT"] = "EU_VAT";
    TaxTypeConfigurationTaxType["JAPAN_JCT"] = "JAPAN_JCT";
    TaxTypeConfigurationTaxType["AU_GST"] = "AU_GST";
    TaxTypeConfigurationTaxType["BR_CNPJ"] = "BR_CNPJ";
    TaxTypeConfigurationTaxType["RU_TIN"] = "RU_TIN";
    TaxTypeConfigurationTaxType["IN_RNR"] = "IN_RNR";
    TaxTypeConfigurationTaxType["IL_VAT"] = "IL_VAT";
    TaxTypeConfigurationTaxType["US_TAX"] = "US_TAX";
    TaxTypeConfigurationTaxType["SG_GST"] = "SG_GST";
    TaxTypeConfigurationTaxType["CA_GST"] = "CA_GST";
    TaxTypeConfigurationTaxType["CA_HST"] = "CA_HST";
    TaxTypeConfigurationTaxType["CA_PST"] = "CA_PST";
    TaxTypeConfigurationTaxType["CA_QST"] = "CA_QST";
    TaxTypeConfigurationTaxType["NZ_GST"] = "NZ_GST";
    TaxTypeConfigurationTaxType["MD_VAT"] = "MD_VAT";
    TaxTypeConfigurationTaxType["CL_VAT"] = "CL_VAT";
    TaxTypeConfigurationTaxType["MY_VAT"] = "MY_VAT";
    TaxTypeConfigurationTaxType["KR_VAT"] = "KR_VAT";
    TaxTypeConfigurationTaxType["TW_VAT"] = "TW_VAT";
    TaxTypeConfigurationTaxType["AE_VAT"] = "AE_VAT";
    TaxTypeConfigurationTaxType["NG_VAT"] = "NG_VAT";
    TaxTypeConfigurationTaxType["IS_VAT"] = "IS_VAT";
    TaxTypeConfigurationTaxType["GE_VAT"] = "GE_VAT";
    TaxTypeConfigurationTaxType["TH_VAT"] = "TH_VAT";
    TaxTypeConfigurationTaxType["TR_VAT"] = "TR_VAT";
    TaxTypeConfigurationTaxType["NO_VAT"] = "NO_VAT";
    TaxTypeConfigurationTaxType["UA_VAT"] = "UA_VAT";
    TaxTypeConfigurationTaxType["IN_GST"] = "IN_GST";
    TaxTypeConfigurationTaxType["KZ_VAT"] = "KZ_VAT";
    TaxTypeConfigurationTaxType["TZ_VAT"] = "TZ_VAT";
    TaxTypeConfigurationTaxType["IGIC_VAT"] = "IGIC_VAT";
    TaxTypeConfigurationTaxType["KE_VAT"] = "KE_VAT";
})(TaxTypeConfigurationTaxType = exports.TaxTypeConfigurationTaxType || (exports.TaxTypeConfigurationTaxType = {}));
var ValidateNoPreviousPurchaseType;
(function (ValidateNoPreviousPurchaseType) {
    ValidateNoPreviousPurchaseType["UNKNOWN"] = "UNKNOWN";
    ValidateNoPreviousPurchaseType["OK"] = "OK";
    ValidateNoPreviousPurchaseType["PENDING"] = "PENDING";
    ValidateNoPreviousPurchaseType["DELIVERED"] = "DELIVERED";
    ValidateNoPreviousPurchaseType["SERVER_ERROR"] = "SERVER_ERROR";
})(ValidateNoPreviousPurchaseType = exports.ValidateNoPreviousPurchaseType || (exports.ValidateNoPreviousPurchaseType = {}));
//# sourceMappingURL=types.js.map